// src/core/companySettings/index.js
import { http } from 'shared/api/http';

export const companySettingsApi = {
  getMy() {
    return http('/api/v1/company-settings/me', { method: 'GET' });
  },

  saveMySetup(payload) {
    return http('/api/v1/company-settings/me/setup', {
      method: 'POST',
      body: payload,
    });
  },

  updateMyIdentity(payload) {
    return http('/api/v1/company-settings/me/identity', {
      method: 'PATCH',
      body: payload,
    });
  },

  // (istersen kalsın)
  updateCalendarType(calendarType) {
    return http('/api/v1/company-settings/me/tools/calendar-type', {
      method: 'PATCH',
      body: { calendarType },
    });
  },

  // ✅ yeni: tools komple update
  updateMyTools(payload) {
    return http('/api/v1/company-settings/me/tools', {
      method: 'PATCH',
      body: payload,
    });
  },

  // ✅ (opsiyonel) geriye dönük uyumluluk için alias:
  updateTools(payload) {
    return this.updateMyTools(payload);
  },
};
